// Pantheon panel — slot/unslot temperament cards into 3 weighted slots.
// Pure mutations live in systems/pantheon.js; this is the UI layer.
import { render } from 'preact';
import { TEMPERAMENTS, PANTHEON_SLOT_NAMES, PANTHEON_SLOT_WEIGHTS, PANTHEON_SWAP_COST } from '../content/temperaments.js';
import { state } from '../systems/state.js';
import { pantheonSlot, pantheonUnslot } from '../systems/pantheon.js';
import { toast } from './toast.js';
import { useStore } from './use-store.js';

let onRefreshMenu = null;
export function initPantheonUi({ onRefreshMenuCb }) { onRefreshMenu = onRefreshMenuCb; }

function doSlot(slotIdx, tempId) {
  const occupied = !!state.pantheon[slotIdx];
  if (occupied && (state.crumbs || 0) < PANTHEON_SWAP_COST) {
    toast(`swap costs ${PANTHEON_SWAP_COST} 🍞`);
    return;
  }
  if (pantheonSlot(slotIdx, tempId) && onRefreshMenu) onRefreshMenu();
}

function doUnslot(slotIdx) {
  pantheonUnslot(slotIdx);
  if (onRefreshMenu) onRefreshMenu();
}

function Slots() {
  useStore();
  return (
    <>
      {[0, 1, 2].map(i => {
        const tempId = state.pantheon ? state.pantheon[i] : null;
        const t = tempId ? TEMPERAMENTS.find(x => x.id === tempId) : null;
        return (
          <div
            key={i}
            className={'pantheon-slot' + (t ? '' : ' empty')}
            onClick={t ? () => doUnslot(i) : undefined}
          >
            <div className="slot-name">{PANTHEON_SLOT_NAMES[i]}</div>
            <div className="slot-weight">×{PANTHEON_SLOT_WEIGHTS[i]}</div>
            <div className="slot-icon">{t ? t.icon : '○'}</div>
            <div className="slot-name-filled">{t ? t.name : 'empty'}</div>
          </div>
        );
      })}
    </>
  );
}

function Pool() {
  useStore();
  return (
    <>
      {TEMPERAMENTS.map(t => {
        const slottedAt = (state.pantheon || []).indexOf(t.id);
        const isSlotted = slottedAt >= 0;
        return (
          <div key={t.id} className={'temperament' + (isSlotted ? ' slotted' : '')}>
            <div className="temp-icon">{t.icon}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="temp-name">
                {t.name}
                {isSlotted && (
                  <span style={{ opacity: 0.6, fontWeight: 400 }}> ({PANTHEON_SLOT_NAMES[slottedAt]})</span>
                )}
              </div>
              <div className="temp-desc">{t.desc}</div>
            </div>
            <div className="temp-actions">
              {isSlotted ? (
                <button className="slot-btn unslot" onClick={() => doUnslot(slottedAt)}>unslot</button>
              ) : (
                [0, 1, 2].map(i => {
                  const occupied = !!state.pantheon[i];
                  const cantAfford = occupied && (state.crumbs || 0) < PANTHEON_SWAP_COST;
                  return (
                    <button
                      key={i}
                      className="slot-btn"
                      title={`slot in ${PANTHEON_SLOT_NAMES[i]} (×${PANTHEON_SLOT_WEIGHTS[i]})${occupied ? ` — costs ${PANTHEON_SWAP_COST} 🍞` : ''}`}
                      disabled={cantAfford}
                      onClick={() => doSlot(i, t.id)}
                    >
                      {PANTHEON_SLOT_NAMES[i].charAt(0)}
                    </button>
                  );
                })
              )}
            </div>
          </div>
        );
      })}
    </>
  );
}

export function mountPantheonUi() {
  const slotsEl = document.getElementById('pantheon-slots');
  const poolEl = document.getElementById('pantheon-pool');
  if (!slotsEl || !poolEl) return;
  render(<Slots />, slotsEl);
  render(<Pool />, poolEl);
}

